import { EnKeysProps } from './en';

export const en: EnKeysProps = {
  'header.betslipBtn.desc': 'Slip',
  'error.heading': `Houston, we have a problem!`,
  'error.description': `<bold>We’re sorry about that. We’ve got someone on it.</bold>
  In the meantime, you can refresh the page, or try again later.`,
  'maintenance.error': `<bold>We’re currently performing maintenance on the site.</bold>
  In the meantime, you can refresh the page, or try again later.`,
  'maintenance.heading': `System malfunction!`,
  'onboarding.locationnotallowed.header': 'Out of orbit!',
  'onboarding.locationnotallowed.subheader':
    'You seem to be accessing EpicOdds from outside of Australia.',
  'onboarding.locationnotallowed.registration': '',
  'betslip.betslipbetcard.errors.propositionclosed': 'This event is closed',
  'sports.allsports.azheading': 'Sports',
  'betslip.betslipmodal.emptybetslipheading': 'Make it epic!',
  'betslip.betslipmodal.emptybetslipsubheading':
    'Add your selections to get started.',
  'footer.footerparagraph':
    "{themeName} gambling operations are governed by our <rglink>Responsible Gambling Code of Conduct</rglink>. Think about your choices. Call Gambler's Help or Gambling Help on <telLink>1800 858 858</telLink> or visit <link>gamblershelp.com.au</link> or <link>gamblinghelponline.org.au</link>. Call Gambler's Help Youthline on <telLink>1800 262 376</telLink>. Gamble Responsibly.",
  'footer.ourpartners': 'Approved Betting Operator Of',
  'footer.licensedandregulated':
    'Licensed and regulated by the Northern Territory Wagering Commission.',
};
